<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section class="tw-mb-3">
        <fieldset class="tw-py-30px">
          <legend>
            {{ pageVocabs + "legends.general" | translate }}
          </legend>
          <div class="row">
            <!-- userName -->
            <div class="md:tw-w-1/2" *ngIf="this.formPageConfig.isEditMode">
              <form-field
                [value]="this.formPageConfig.editData.userName"
                [control]="form?.get('userName')"
                label="common.userName"
              >
              </form-field>
            </div>

            <!-- privateNumberNumber -->
            <div class="md:tw-w-1/2" *ngIf="this.formPageConfig.isEditMode">
              <form-field
                [value]="this.formPageConfig.editData.privateNumberNumber"
                [control]="form?.get('privateNumber')"
                label="common.privateNumber"
              >
              </form-field>
            </div>

            <!-- canSeeReceivedSms -->
            <div class="sm:tw-w-1/2">
              <mat-slide-toggle
                formControlName="canSeeReceivedSms"
                [(ngModel)]="model.canSeeReceivedSms"
              >
                {{ fields + "canSeeReceivedSms" | translate }}</mat-slide-toggle
              >
            </div>
          </div>
        </fieldset>
      </section>

      <!-- sendTypesList -->
      <section>
        <fieldset class="tw-py-30px">
          <legend>
            {{ pageVocabs + "legends.sendTypesList" | translate }}
          </legend>

          <div class="row">
            <!-- sendTypesList -->
            <div class="tw-w-full">
              <enum-selection-list
                [values]="model.sendTypesList"
                (values)="model.sendTypesList = $event"
                searchLabel="common.search"
                [enumType]="SendTypes"
                [isSmallSize]="true"
                enumName="SendTypes"
                controlName="sendTypesList"
              >
              </enum-selection-list>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- users -->
      <section *ngIf="!formPageConfig.isEditMode && !usersId">
        <fieldset class="tw-py-30px">
          <legend>
            {{ pageVocabs + "legends.users" | translate }}
          </legend>
          <div class="row">
            <!-- userIds -->
            <div class="tw-w-full">
              <user-selection-list
                [type]="'usersListByOrganizationId'"
                [id]="permissionService.userState()?.organizationId"
                [optionValue]="'id'"
                searchLabel="messages.searchInUsers"
                [values]="model.userIds"
                (values)="model.userIds = $event"
                controlName="userIds"
              >
              </user-selection-list>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- privateNumbers -->
      <section *ngIf="!formPageConfig.isEditMode">
        <fieldset class="tw-py-30px">
          <legend>
            {{ pageVocabs + "legends.privateNumbers" | translate }}
          </legend>
          <div class="row">
            <!-- privateNumberIds -->
            <div class="tw-w-full">
              <private-number-selection-list
                searchLabel="messages.searchInPrivateNumbers"
                [values]="model.privateNumberIds"
                (values)="model.privateNumberIds = $event"
                controlName="privateNumberIds"
              >
              </private-number-selection-list>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
